import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {change_size_type} from "../redux/actions";
import {OverallVolume} from "./fields/OverallVolume";
import {Sizes} from "./fields/Sizes";

export const SizeType = () => {
    const dispatch = useDispatch()
    const sizeType = useSelector(state => state.app.sizeType)
    return (
        <React.Fragment>
            <div className="front-calc__tabs">
                <div className={'front-calc__tabs_btn' + ' ' + (sizeType === 1 ? 'current' : '')}
                     onClick={() => dispatch(change_size_type(1))}
                >
                    Указать общий объем
                </div>
                <div className={'front-calc__tabs_btn' + ' ' + (sizeType === 2 ? 'current' : '')}
                     onClick={() => dispatch(change_size_type(2))}
                >
                    Указать габариты каждого груза
                </div>
            </div>
            {
                sizeType === 1 && (
                    <div className="front-calc__tab front-calc__tab_1 current">
                        {<OverallVolume/>}
                    </div>
                )
            }
            {
                sizeType === 2 && (
                    <div className="front-calc__tab front-calc__tab_2 current">
                        <Sizes/>
                    </div>
                )
            }


        </React.Fragment>
    )
}